// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col > p {
  border: 1px solid var(--accent);
  padding: 0.5rem;
}

span, label {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/components/expedientes-detalle-prorroga/expedientes-detalle-prorroga.component.scss"],"names":[],"mappings":"AAAA;EACI,+BAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":[".col > p {\n    border: 1px solid var(--accent);\n    padding: 0.5rem;\n}\n\nspan, label {\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
